export default "__VITE_ASSET__6d86da59__"